module.exports = __webpack_public_path__ + "static/media/cruise.bf26de23.png";